<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
     :pageName="pageName"
      :userName="userName"
  >
   <template v-slot:body>
   <div class="row p-0  align-items-center rental-payment">
            <div class="col mt-4 ms-lg-5 ms-md-5">
              <h4 class="rental-heading">{{ formattedServiceName }}</h4>
            </div>
            
            <div class="col d-flex justify-content-end m-lg-4  back-btn me-md-4">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary d-none d-sm-block new-btn"
                @click="BackToServices()"
              >
                Back To Services
              </llp-button>
                <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary d-block d-sm-none new-btn go-back-services"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
  <div class="row bbps-row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div v-if="loading" class="loader-container">
        <div class="spinner"></div>
      </div>

      <div v-else class="row bbps-services-grid m-4">
        <div
          v-for="(service, index) in bbpsService"
          :key="index"
          class="col-lg-2 col-md-4 col-6 mb-3"
        >
          <div
            class="bbps-service-card text-center"
            @click="goToServicePage(service.id)"
          >
            <div class="bbps-service-icon mb-2">
              <i :class="service.icon_name"></i>
            </div>
            <div class="bbps-service-name">{{ service.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
   </template>
</llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>


<script>
import NetworkService from '@/services/network.service';
import ErrorService from "../../../services/error.service";
// import BPPSData from "@/components/jsonData/ServicesDetails.json";
export default {
  setup() {},
  data() {
    return {
      loading: true,
      bbpsService: [],
      categoriesId:'',
     serviceName: this.$route.params.serviceName,
    service_id :this.$route.params.serviceId

    };
  },
  computed: {
    // Computed property to format serviceName
    formattedServiceName() {
      return this.serviceName
        .replace(/-/g, ' ') 
        .replace(/\b\w/g, (char) => char.toUpperCase()); 
    },
     formattedServiceNameForMobile() {
    return this.serviceName
      .replace(/Utility/i, '')  
      .replace(/-/g, ' ')  
      .replace(/\b\w/g, (char) => char.toUpperCase());  
  }
  },
  mounted() {
    this.fetchingServiceDetails();
   
  },
  
  methods: {
    BackToServices() {
      this.$router.push(`/services`);
    },
    goToServicePage(id) {
      
      this.$router.push({ name: "service-category", params: {service_id:this.service_id,category_id:id} });
    },
    async fetchingServiceDetails() {
      try {

         const response = await NetworkService.get(`get-categories?service=${this.serviceName}`);
         this.bbpsService = response.categories
       
        // this.bbpsService = BPPSData.categories;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.message) {
          this.$refs.toast.show("No service avaible,Coming soon.", "error");
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },
  },
};
</script>
